// // import { useEffect, useState } from "react";
// // import { Button, Flex, Modal, Spin, message } from "antd";
// // import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
// // import ReactFlow, {
// //   Background,
// //   Controls,
// //   MiniMap,
// //   useNodesState,
// //   useEdgesState,
// // } from "reactflow";
// // import dagre from "dagre";
// // import "reactflow/dist/style.css";
// // import {
// //   fetchProduct,
// //   postProduct,
// //   putProduct,
// //   deleteProduct,
// // } from "../Service/product";
// // import ProductForm from "./productForm";

// // const nodeWidth = 180;
// // const nodeHeight = 80;

// // function buildFlowElements(treeData, onEdit, onDelete) {
// //   const g = new dagre.graphlib.Graph();
// //   g.setDefaultEdgeLabel(() => ({}));
// //   g.setGraph({ rankdir: "TB" });

// //   const nodes = [];
// //   const edges = [];

// //   const traverse = (item, parentId = null) => {
// //     const id = item.id.toString();
// //     const hasChildren =
// //       Array.isArray(item.children) && item.children.length > 0;

// //     g.setNode(id, { width: nodeWidth, height: nodeHeight });

// //     nodes.push({
// //       id,
// //       data: {
// //         label: (
// //           <div style={{ padding: 8 }}>
// //             <b>{item.productName}</b>
// //             <br />
// //             <EditOutlined
// //               onClick={(e) => {
// //                 e.stopPropagation();
// //                 onEdit(item);
// //               }}
// //               style={{ marginRight: 8, cursor: "pointer" }}
// //             />
// //             {/* ✅ Only show delete if no children */}
// //             {!hasChildren && (
// //               <DeleteOutlined
// //                 onClick={(e) => {
// //                   e.stopPropagation();
// //                   onDelete(item.id);
// //                 }}
// //                 style={{ cursor: "pointer", color: "red" }}
// //               />
// //             )}
// //           </div>
// //         ),
// //       },
// //       position: { x: 0, y: 0 },
// //       draggable: false,
// //       style: {
// //         border: "1px solid #777",
// //         borderRadius: "6px",
// //         background: "#fff",
// //       },
// //     });

// //     if (parentId) {
// //       g.setEdge(parentId, id);
// //       edges.push({ id: `${parentId}-${id}`, source: parentId, target: id });
// //     }

// //     item.children?.forEach((child) => traverse(child, id));
// //   };

// //   treeData.forEach((root) => traverse(root));

// //   dagre.layout(g);

// //   const positionedNodes = nodes.map((node) => {
// //     const { x, y } = g.node(node.id);
// //     return {
// //       ...node,
// //       position: { x, y },
// //     };
// //   });

// //   return { nodes: positionedNodes, edges };
// // }

// // export const buildTreeData = (nodes) =>
// //   nodes.map((node) => {
// //     const isLeaf = !node.children || node.children.length === 0;
// //     return {
// //       title: node.productName,
// //       value: node.id,
// //       key: node.id,
// //       selectable: isLeaf,
// //       disabled: !isLeaf,
// //       children: node.children ? buildTreeData(node.children) : [],
// //     };
// //   });

// // // --- Component ---
// // const Product = () => {
// //   const [isModalOpen, setIsModalOpen] = useState(false);
// //   const [editData, setEditData] = useState(null);
// //   const [nodes, setNodes, onNodesChange] = useNodesState([]);
// //   const [edges, setEdges, onEdgesChange] = useEdgesState([]);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [messageApi, contextHolder] = message.useMessage();

// //   const fetchData = async () => {
// //     setIsLoading(true);
// //     try {
// //       const res = await fetchProduct(); // axios response object
// //       const tree = res.data; // since backend returns array directly

// //       const { nodes, edges } = buildFlowElements(
// //         tree,
// //         (d) => {
// //           setEditData(d);
// //           setIsModalOpen(true);
// //         },
// //         async (id) => {
// //           await deleteData(id);
// //         }
// //       );

// //       setNodes(nodes);
// //       setEdges(edges);
// //     } catch (err) {
// //       message.error("Network error while fetching products");
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   const saveData = async (data) => {
// //     setIsLoading(true);
// //     try {
// //       let resp;

// //       if (editData) {
// //         // Editing existing product
// //         resp = await putProduct(editData.id, data);
// //       } else {
// //         // Creating new product
// //         resp = await postProduct(data);
// //       }

// //       if (resp) {
// //         await fetchData(); // refresh product tree
// //         setIsModalOpen(false);
// //         setEditData(null);
// //         return true; // tells form to reset
// //       }
// //       messageApi.open({
// //         type: "success",
// //         content: `Product ${editData ? "updated" : "added"} successfully`,
// //       });
// //       return false;
// //     } catch (err) {
// //       messageApi.open({
// //         type: "error",
// //         content: ("Save product failed:", err),
// //       });
// //       return false;
// //     }
// //   };

// //   const deleteData = async (id) => {
// //     try {
// //       const res = await deleteProduct(id);
// //       messageApi.open({
// //         type: "success",
// //         content: "Product deleted successfully",
// //       });
// //       fetchData();
// //     } catch (err) {
// //       messageApi.open({
// //         type: "error",
// //         content: "Error while deleting product",
// //       });
// //     }
// //   };

// //   const handleCancel = () => {
// //     fetchData();
// //     setIsModalOpen(false);
// //     setEditData(null);
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, []);

// //   return (
// //     <Spin spinning={isLoading}>
// //       <div style={{ width: "100%", height: "70vh" }}>
// //         {contextHolder}
// //         <Flex
// //           justify="space-between"
// //           align="center"
// //           style={{ marginBottom: 16 }}
// //         >
// //           <div style={{ fontSize: "1rem", fontWeight: 700 }}>Product</div>
// //           <Button onClick={() => setIsModalOpen(true)} type="primary">
// //             Add
// //           </Button>
// //         </Flex>

// //         <ReactFlow
// //           nodes={nodes}
// //           edges={edges}
// //           onNodesChange={onNodesChange}
// //           onEdgesChange={onEdgesChange}
// //           fitView
// //         >
// //           <Controls />
// //           <MiniMap />
// //           <Background />
// //         </ReactFlow>

// //         <Modal
// //           title="Product Form"
// //           centered
// //           closable
// //           open={isModalOpen}
// //           footer={false}
// //           onCancel={handleCancel}
// //         >
// //           <ProductForm
// //             editData={editData}
// //             saveData={saveData}
// //             isModalOpen={isModalOpen}
// //           />
// //         </Modal>
// //       </div>
// //     </Spin>
// //   );
// // };

// // export default Product;
// import { useEffect, useState } from "react";
// import { Button, Flex, Modal, Spin, message, Popconfirm } from "antd";
// import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
// import ReactFlow, {
//   Background,
//   Controls,
//   MiniMap,
//   useNodesState,
//   useEdgesState,
// } from "reactflow";
// import dagre from "dagre";
// import "reactflow/dist/style.css";
// import {
//   fetchProduct,
//   postProduct,
//   putProduct,
//   deleteProduct,
// } from "../Service/product";
// import ProductForm from "./productForm";

// const nodeWidth = 180;
// const nodeHeight = 100;

// function buildFlowElements(treeData, onEdit, onDelete) {
//   const g = new dagre.graphlib.Graph();
//   g.setDefaultEdgeLabel(() => ({}));
//   g.setGraph({ rankdir: "TB", nodesep: 40, ranksep: 70 });

//   const nodes = [];
//   const edges = [];

//   const traverse = (item, parentId = null) => {
//     const id = item.id.toString();
//     const hasChildren =
//       Array.isArray(item.children) && item.children.length > 0;

//     g.setNode(id, { width: nodeWidth, height: nodeHeight });

//     nodes.push({
//       id,
//       draggable: false,
//       data: {
//         label: (
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               padding: 10,
//               boxSizing: "border-box",
//             }}
//           >
//             <div
//               style={{
//                 fontWeight: 600,
//                 fontSize: 14,
//                 marginBottom: 6,
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               {item.productName}
//             </div>

//             <Flex justify="center" gap={12}>
//               <EditOutlined
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   onEdit(item);
//                 }}
//                 style={{ color: "#1677ff", cursor: "pointer" }}
//               />
//               {!hasChildren && (
//                 <Popconfirm
//                   title="Delete Product"
//                   description="Are you sure you want to delete this product?"
//                   okText="Yes"
//                   cancelText="No"
//                   placement="left"
//                   okButtonProps={{ danger: true }}
//                   onConfirm={(e) => {
//                     e?.stopPropagation();
//                     onDelete(item.id);
//                   }}
//                   onCancel={(e) => e?.stopPropagation()}
//                 >
//                   <DeleteOutlined
//                     onClick={(e) => e.stopPropagation()}
//                     style={{ color: "red", cursor: "pointer" }}
//                   />
//                 </Popconfirm>
//               )}
//             </Flex>
//           </div>
//         ),
//       },
//       position: { x: 0, y: 0 },
//       style: {
//         width: nodeWidth,
//         height: nodeHeight,
//         border: "1px solid #d9d9d9",
//         borderRadius: 8,
//         background: "#fff",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//       },
//     });

//     if (parentId) {
//       g.setEdge(parentId, id);
//       edges.push({ id: `${parentId}-${id}`, source: parentId, target: id });
//     }

//     item.children?.forEach((child) => traverse(child, id));
//   };

//   treeData.forEach((root) => traverse(root));

//   dagre.layout(g);

//   const positionedNodes = nodes.map((node) => {
//     const { x, y } = g.node(node.id);
//     return {
//       ...node,
//       position: { x: x - nodeWidth / 2, y: y - nodeHeight / 2 },
//     };
//   });

//   return { nodes: positionedNodes, edges };
// }
// export const buildTreeData = (nodes) =>
//   nodes.map((node) => {
//     const isLeaf = !node.children || node.children.length === 0;
//     return {
//       title: node.productName,
//       value: node.uuid,
//       key: node.uuid,
//       selectable: isLeaf,
//       disabled: !isLeaf,
//       children: node.children ? buildTreeData(node.children) : [],
//     };
//   });
// // --- Component ---
// const Product = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [nodes, setNodes, onNodesChange] = useNodesState([]);
//   const [edges, setEdges, onEdgesChange] = useEdgesState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const fetchData = async () => {
//     setIsLoading(true);
//     try {
//       const res = await fetchProduct();
//       const tree = res.data || [];

//       const { nodes, edges } = buildFlowElements(
//         tree,
//         setEditDataAndOpenModal,
//         deleteData
//       );

//       setNodes(nodes);
//       setEdges(edges);
//     } catch {
//       messageApi.error("Failed to fetch product data");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const setEditDataAndOpenModal = (item) => {
//     setEditData(item);
//     setIsModalOpen(true);
//   };

//   const saveData = async (data) => {
//     setIsLoading(true);
//     try {
//       if (editData) {
//         await putProduct(editData.id, data);
//       } else {
//         await postProduct(data);
//       }
//       messageApi.success(
//         `Product ${editData ? "updated" : "added"} successfully`
//       );
//       setIsModalOpen(false);
//       setEditData(null);
//       fetchData();
//       return true;
//     } catch (err) {
//       messageApi.error(err.message || "Save failed");
//       return false;
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const deleteData = async (id) => {
//     try {
//       await deleteProduct(id);
//       messageApi.success("Product deleted successfully");
//       fetchData();
//     } catch {
//       messageApi.error("Delete failed");
//     }
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//     setEditData(null);
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   return (
//     <Spin spinning={isLoading}>
//       {contextHolder}
//       <div style={{ width: "100%", height: "70vh" }}>
//         <Flex
//           justify="space-between"
//           align="center"
//           style={{ marginBottom: 16 }}
//         >
//           <div style={{ fontSize: 16, fontWeight: 600 }}>Product</div>
//           <Button type="primary" onClick={() => setIsModalOpen(true)}>
//             Add
//           </Button>
//         </Flex>

//         <ReactFlow
//           nodes={nodes}
//           edges={edges}
//           onNodesChange={onNodesChange}
//           onEdgesChange={onEdgesChange}
//           fitView
//         >
//           <Controls />
//           <MiniMap />
//           <Background />
//         </ReactFlow>

//         <Modal
//           title="Product Form"
//           centered
//           open={isModalOpen}
//           footer={null}
//           onCancel={handleCancel}
//         >
//           <ProductForm
//             editData={editData}
//             saveData={saveData}
//             isModalOpen={isModalOpen}
//           />
//         </Modal>
//       </div>
//     </Spin>
//   );
// };

// export default Product;

import { useEffect, useState } from "react";
import { Button, Flex, Modal, Spin, message, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import ReactFlow, {
  Background, Controls, MiniMap, useNodesState, useEdgesState,
} from "reactflow";
import dagre from "dagre";
import "reactflow/dist/style.css";
import { fetchProduct, postProduct, putProduct, deleteProduct } from "../Service/product";
import ProductForm from "./productForm";
import usePermission from "../../../../hooks/usePermission";

const nodeWidth = 180;
const nodeHeight = 100;

function buildFlowElements(treeData, onEdit, onDelete, canUpdate, canDelete_) {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: "TB", nodesep: 40, ranksep: 70 });

  const nodes = [];
  const edges = [];

  const traverse = (item, parentId = null) => {
    const id = item.id.toString();
    const hasChildren = Array.isArray(item.children) && item.children.length > 0;
    g.setNode(id, { width: nodeWidth, height: nodeHeight });

    nodes.push({
      id,
      draggable: false,
      data: {
        label: (
          <div style={{ width: "100%", height: "100%", padding: 10, boxSizing: "border-box" }}>
            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {item.productName}
            </div>
            <Flex justify="center" gap={12}>
              {canUpdate && (
                <EditOutlined
                  onClick={(e) => { e.stopPropagation(); onEdit(item); }}
                  style={{ color: "#1677ff", cursor: "pointer" }}
                />
              )}
              {canDelete_ && !hasChildren && (
                <Popconfirm
                  title="Delete Product" description="Are you sure you want to delete this product?"
                  okText="Yes" cancelText="No" placement="left" okButtonProps={{ danger: true }}
                  onConfirm={(e) => { e?.stopPropagation(); onDelete(item.id); }}
                  onCancel={(e) => e?.stopPropagation()}
                >
                  <DeleteOutlined onClick={(e) => e.stopPropagation()} style={{ color: "red", cursor: "pointer" }} />
                </Popconfirm>
              )}
            </Flex>
          </div>
        ),
      },
      position: { x: 0, y: 0 },
      style: { width: nodeWidth, height: nodeHeight, border: "1px solid #d9d9d9", borderRadius: 8, background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" },
    });

    if (parentId) {
      g.setEdge(parentId, id);
      edges.push({ id: `${parentId}-${id}`, source: parentId, target: id });
    }

    item.children?.forEach((child) => traverse(child, id));
  };

  treeData.forEach((root) => traverse(root));
  dagre.layout(g);

  const positionedNodes = nodes.map((node) => {
    const { x, y } = g.node(node.id);
    return { ...node, position: { x: x - nodeWidth / 2, y: y - nodeHeight / 2 } };
  });

  return { nodes: positionedNodes, edges };
}

export const buildTreeData = (nodes) =>
  nodes.map((node) => {
    const isLeaf = !node.children || node.children.length === 0;
    return {
      title: node.productName,
      value: node.uuid,
      key: node.uuid,
      selectable: isLeaf,
      disabled: !isLeaf,
      children: node.children ? buildTreeData(node.children) : [],
    };
  });

const Product = () => {
  const { canCreate, canUpdate, canDelete } = usePermission("CONFIG_PRODUCT");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await fetchProduct();
      const tree = res.data || [];
      const { nodes, edges } = buildFlowElements(tree, setEditDataAndOpenModal, deleteData, canUpdate, canDelete);
      setNodes(nodes);
      setEdges(edges);
    } catch {
      messageApi.error("Failed to fetch product data");
    } finally {
      setIsLoading(false);
    }
  };

  const setEditDataAndOpenModal = (item) => { setEditData(item); setIsModalOpen(true); };

  const saveData = async (data) => {
    setIsLoading(true);
    try {
      if (editData) { await putProduct(editData.id, data); }
      else { await postProduct(data); }
      messageApi.success(`Product ${editData ? "updated" : "added"} successfully`);
      setIsModalOpen(false);
      setEditData(null);
      fetchData();
      return true;
    } catch (err) {
      messageApi.error(err.message || "Save failed");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const deleteData = async (id) => {
    try {
      await deleteProduct(id);
      messageApi.success("Product deleted successfully");
      fetchData();
    } catch {
      messageApi.error("Delete failed");
    }
  };

  const handleCancel = () => { setIsModalOpen(false); setEditData(null); };

  useEffect(() => { fetchData(); }, []);

  return (
    <Spin spinning={isLoading}>
      {contextHolder}
      <div style={{ width: "100%", height: "70vh" }}>
        <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>Product</div>
          {canCreate && (
            <Button type="primary" onClick={() => setIsModalOpen(true)}>Add</Button>
          )}
        </Flex>
        <ReactFlow nodes={nodes} edges={edges} onNodesChange={onNodesChange} onEdgesChange={onEdgesChange} fitView>
          <Controls /><MiniMap /><Background />
        </ReactFlow>
        <Modal title="Product Form" centered open={isModalOpen} footer={null} onCancel={handleCancel}>
          <ProductForm editData={editData} saveData={saveData} isModalOpen={isModalOpen} />
        </Modal>
      </div>
    </Spin>
  );
};

export default Product;